"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var deepmerge_1 = __importDefault(require("deepmerge"));
var react_1 = __importDefault(require("react"));
var core_1 = require("../../shared/core");
var registers_1 = require("../../shared/core/utils/registers");
var analytics_subjects_1 = require("./analytics-subjects");
var handle_bill_download_1 = require("./utils/handle-bill-download");
function HowBillingWorksLink(_a) {
    var _b;
    var children = _a.children;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var howBillingWorks = (0, core_1.useLinks)().howBillingWorks;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.BILLING_DETAILS_HELP_LINK, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(TextLink, { "data-testid": "help-link-billing", href: howBillingWorks() }, children)));
}
function HelpNegativeChargeLink(_a) {
    var children = _a.children;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var helpNegativeCharge = (0, core_1.useLinks)().helpNegativeCharge;
    return (react_1.default.createElement(TextLink, { "data-testid": "help-link-negative-charge", href: helpNegativeCharge() }, children));
}
function MeterReadsLink(_a) {
    var _b;
    var children = _a.children, fuel = _a.fuel;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var meterReads = (0, core_1.useLinks)().meterReads;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.BILLING_HISTORY_PAGE_SUBMIT_METER_READ, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b.fuel = fuel, _b) },
        react_1.default.createElement(TextLink, { "data-testid": "meter-reads-link", href: meterReads() }, children)));
}
function NoChargesLink(_a) {
    var children = _a.children, fuelType = _a.fuelType;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var meterReadsNew = (0, core_1.useLinks)().meterReadsNew;
    return (react_1.default.createElement(TextLink, { "data-testid": "no-charges-meter-reading-link", href: meterReadsNew({ fuelType: fuelType }) }, children));
}
function CapitalisedRegisterLabel(_a) {
    var friendlyLabel = _a.friendlyLabel;
    return react_1.default.createElement(registers_1.RegisterLabel, { friendlyLabel: friendlyLabel, capitalise: true });
}
function HelpCentreLink(_a) {
    var children = _a.children;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var helpCentre = (0, core_1.useLinks)().helpCentre;
    return react_1.default.createElement(TextLink, { href: helpCentre() }, children);
}
function DownloadBillLink(_a) {
    var children = _a.children, accountId = _a.accountId, from = _a.from, to = _a.to;
    var _b = (0, core_1.useComponents)(), TextLink = _b.TextLink, Icon = _b.Icon;
    var billingStatementDownload = (0, core_1.useLinks)().billingStatementDownload;
    var url = billingStatementDownload({
        accountId: accountId,
        from: from,
        to: to,
    });
    return (react_1.default.createElement(core_1.Feature, { feature: "osv1Download" }, function (enabled) {
        var _a, _b;
        return enabled ? (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.DOWNLOAD_BILL, properties: (_a = {}, _a[core_1.INTERNAL_EVENT_FLAG] = true, _a.osv1Fix = true, _a) },
            react_1.default.createElement(TextLink, { "data-testid": "downloadbill-link", download: true, href: url, onClick: function (e) {
                    e.preventDefault();
                    (0, handle_bill_download_1.handleDownloadBillClick)(url, from, to);
                } },
                react_1.default.createElement(Icon, { name: "download" }),
                " ",
                children))) : (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.DOWNLOAD_BILL, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
            react_1.default.createElement(TextLink, { "data-testid": "downloadbill-link", download: true, href: url },
                react_1.default.createElement(Icon, { name: "download" }),
                " ",
                children)));
    }));
}
function ViewDetailsLink(_a) {
    var _b;
    var children = _a.children, periodId = _a.periodId;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var billingDetails = (0, core_1.useLinks)().billingDetails;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.BILLING_VIEW_DETAILS, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(TextLink, { "data-testid": "viewdetails-link", href: billingDetails({ periodId: periodId }) }, children)));
}
function CurrentBillingPeriodLink(_a) {
    var _b;
    var children = _a.children;
    var _c = (0, core_1.useComponents)(), TextLink = _c.TextLink, InternalLink = _c.InternalLink;
    var billingDetails = (0, core_1.useLinks)().billingDetails;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.BILLING_VIEW_DETAILS, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(TextLink, { as: InternalLink, href: billingDetails() }, children)));
}
function PayAmountLink(_a) {
    var _b;
    var children = _a.children, totalCharge = _a.totalCharge;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var cardPayment = (0, core_1.useLinks)().cardPayment;
    var queryString = new URLSearchParams({ amount: totalCharge });
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.BILLING_PAY_AMOUNT, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(TextLink, { "data-testid": "pay-amount-link", href: "".concat(cardPayment(), "?").concat(queryString) }, children)));
}
function UnderstandBillingLink(_a) {
    var _b;
    var children = _a.children;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var howBillingWorks = (0, core_1.useLinks)().howBillingWorks;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.BILLING_SUMMARY_HELP_LINK, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(TextLink, { "data-testid": 'billing-summary-help-link', href: howBillingWorks() },
            children,
            ' ')));
}
function SendMeterReadingLink(_a) {
    var _b;
    var children = _a.children, fuel = _a.fuel;
    var _c = (0, core_1.useComponents)(), TextLink = _c.TextLink, InternalLink = _c.InternalLink;
    var meterReads = (0, core_1.useLinks)().meterReads;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.BILLING_METER_READING_PROMPT, properties: (_b = { fuel: fuel }, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(TextLink, { as: InternalLink, "data-testid": "send-meter-reads-link", href: meterReads() }, children)));
}
function CreditDebitBalance(_a) {
    var amount = _a.amount;
    var migratedAmount = (0, core_1.major2DP)((0, core_1.majorToMinor)(amount));
    return Number(amount) >= 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
        migratedAmount,
        " in credit")) : (react_1.default.createElement(react_1.default.Fragment, null,
        migratedAmount,
        " in debit"));
}
var keys = {
    title: 'billingHistory.title',
    headerText: 'billingHistory.headerText',
    backtoHome: 'billingHistory.backtoHome',
    viewAllBills: 'billingHistory.viewAllBills',
    viewCurrentBillingPeriod: 'billingHistory.viewCurrentBillingPeriod',
    noBillingTitle: 'billingHistory.noBillingTitle',
    periodEndText: 'billingHistory.periodEndText',
    viewDetails: 'billingHistory.viewDetails',
    startingBalanceLabel: 'billingHistory.startingBalanceLabel',
    totalChargesLabel: 'billingHistory.totalChargesLabel',
    closingBalanceLabel: 'billingHistory.closingBalanceLabel',
    currentBalanceLabel: 'billingHistory.currentBalanceLabel',
    loadMore: 'billingHistory.loadMore',
    migrationTitle: 'billingHistory.migrationTitle',
    migrationTextSingleTransaction: 'billingHistory.migrationTextSingleTransaction',
    migrationTextMultipleTransaction: 'billingHistory.migrationTextMultipleTransaction',
    migrationTextTransactionDetails: 'billingHistory.migrationTextTransactionDetails',
    migrationDual: 'billingHistory.migrationDual',
    migrationSingle: 'billingHistory.migrationSingle',
    migrationMultiple: 'billingHistory.migrationMultiple',
    hasLegacyStatement: 'billingHistory.hasLegacyStatement',
    legacyBillingInfoHeader: 'billingHistory.legacyBillingInfoHeader',
    legacyBillingInfoDescription: 'billingHistory.legacyBillingInfoDescription',
    pending: 'billingHistory.pending',
    totalPaymentsLabel: 'billingHistory.totalPaymentsLabel',
    lastPeriodTitlePrepend: 'billingHistory.lastPeriodTitlePrepend',
    currentPeriodTitlePrepend: 'billingHistory.currentPeriodTitlePrepend',
    paymentsReceivedInPeriod: 'billingHistoryv2.paymentsReceivedInPeriod',
    balanceAfterBill: 'billingHistoryv2.balanceAfterBill',
    downloadBill: 'billingHistoryv2.downloadBill',
    viewFullBill: 'billingHistoryv2.viewFullBill',
    payAmount: 'billingHistoryv2.payAmount',
    closingBalanceInCredit: 'billingHistoryv2.closingBalanceInCredit',
    closingBalanceInDebit: 'billingHistoryv2.closingBalanceInDebit',
    tooltipDeductionDescription: 'billingHistoryv2.tooltipDeductionDescription',
    tooltipDescription: 'billingHistoryv2.tooltipDescription',
    accessibleTooltipDescription: 'billingHistoryv2.accessibleTooltipDescription',
    billingInsightsLabel: 'billingHistoryv2.billingInsightsLabel',
    otherCharges: 'billingHistoryv2.otherCharges',
    credits: 'billingHistoryv2.credits',
    vat: 'billingHistoryv2.vat',
    actualLabel: 'billingHistoryv2.actualLabel',
    accurateEstimateLabel: 'billingHistoryv2.accurateEstimateLabel',
    estimateLabel: 'billingHistoryv2.estimateLabel',
    actualElecLabel: 'billingHistoryv2.actualElecLabel',
    accurateEstimateElecLabel: 'billingHistoryv2.accurateEstimateElecLabel',
    estimateElecLabel: 'billingHistoryv2.estimateElecLabel',
    actualGasLabel: 'billingHistoryv2.actualGasLabel',
    accurateEstimateGasLabel: 'billingHistoryv2.accurateEstimateGasLabel',
    estimateGasLabel: 'billingHistoryv2.estimateGasLabel',
    creditBillLabel: 'billingHistoryv2.creditBillLabel',
    creditInsightTooltip: 'billingHistoryv2.creditInsightTooltip',
    ebbsInsightTooltip: 'billingHistoryv2.ebbsInsightTooltip',
    ebssCredit: 'billingHistoryv2.ebssCredit',
    breakdownLabel: 'billingHistoryv2.breakdownLabel',
    back: 'billingDetails.back',
    billingDetailsTitle: 'billingDetails.billingDetailsTitle',
    billingDetailsTitleV2: 'billingDetails.billingDetailsTitleV2',
    billingDetailsSubtitle: 'billingDetails.billingDetailsSubtitle',
    accessibleTitle: 'billingDetails.accessibleTitle',
    charges: 'billingDetails.charges',
    chargesPending: 'billingDetails.chargesPending',
    download: 'billingDetails.download',
    billingDetailsPending: 'billingDetails.billingDetailsPending',
    balanceHeading: 'billingDetails.balanceHeading',
    currentBalanceHeading: 'billingDetails.currentBalanceHeading',
    balanceLastUpdated: 'billingDetails.balanceLastUpdated',
    currentPeriod: 'billingDetails.currentPeriod',
    daysRemaining: 'billingDetails.daysRemaining',
    totalChargesTitle: 'billingDetails.totalChargesTitle',
    multiRateChargeLabel: 'billingDetails.multiRateChargeLabel',
    chargeLabel: 'billingDetails.chargeLabel',
    helpWithNegativeCharges: 'billingDetails.helpWithNegativeCharges',
    chargeDetailsHeading: 'billingDetails.chargeDetailsHeading',
    chargeDetailsPeak: 'billingDetails.chargeDetailsPeak',
    chargeDetailsOffpeak: 'billingDetails.chargeDetailsOffpeak',
    energyCost: 'billingDetails.energyCost',
    noRecentReadingLink: 'billingDetails.noRecentReadingLink',
    billingTableHeader: 'billingDetails.billingTableHeader',
    dailyEnergyLinkMessage: 'billingDetails.dailyEnergyLinkMessage',
    emptyCurrentStateTitle: 'billingDetails.emptyCurrentStateTitle',
    emptyCurrentStateSubtitle: 'billingDetails.emptyCurrentStateSubtitle',
    emptyCurrentStateBalanceSubtitle: 'billingDetails.emptyCurrentStateBalanceSubtitle',
    emptyCurrentStateBalanceBody: 'billingDetails.emptyCurrentStateBalanceBody',
    emptyCurrentStateBalanceSubmitMeterReading: 'billingDetails.emptyCurrentStateBalanceSubmitMeterReading',
    emptyStateSmartMeterBalanceBody: 'billingDetails.emptyStateSmartMeterBalanceBody',
    emptyStateSmartNonCommsBalanceBody: 'billingDetails.emptyStateSmartNonCommsBalanceBody',
    emptyStateSmartMeterSubtitle: 'billingDetails.emptyStateSmartMeterSubtitle',
    feedbackPromptLabelBillingDetails: 'billingDetails.feedbackPromptLabel',
    feedbackPromptLabelBillingHistory: 'billingHistory.feedbackPromptLabel',
    unitsUsed: 'billingDetails.unitsUsed',
    totalKwh: 'billingDetails.totalKwh',
    sendYourFuelReading: 'billingDetails.sendYourFuelReading',
    upgradesTitle: 'billingDetails.upgradesTitle',
    fuelSectionTitle: 'billingDetails.fuelSectionTitle',
    balanceSectionHeading: 'billingDetails.balanceSectionHeading',
    balanceSectionOpeningHeading: 'billingDetails.balanceSectionOpeningHeading',
    balanceSectionChargesHeading: 'billingDetails.balanceSectionChargesHeading',
    balanceSectionChargesDetails: 'billingDetails.balanceSectionChargesDetails',
    balanceSectionPaymentsHeading: 'billingDetails.balanceSectionPaymentsHeading',
    balanceSectionPaymentsDetails: 'billingDetails.balanceSectionPaymentsDetails',
    balanceSectionClosingHeading: 'billingDetails.balanceSectionClosingHeading',
    gasSectionTitle: 'billingDetails.gasSectionTitle',
    electricitySectionTitle: 'billingDetails.electricitySectionTitle',
    chargesTableTitle: 'billingDetails.chargesTableTitle',
    chargesTableTotalLabel: 'billingDetails.chargesTableTotalLabel',
    noChargesInPeriod: 'billingDetails.noChargesInPeriod',
    inCredit: 'billingDetails.inCredit',
    inDebit: 'billingDetails.inDebit',
    totalChargesSectionHeader: 'billingDetails.totalChargesSectionHeader',
    paymentsSectionHeader: 'billingDetails.paymentsSectionHeader',
    paymentsSectionEmpty: 'billingDetails.paymentsSectionEmpty',
    meterReadingsHeader: 'billingDetails.meterReadingsHeader',
    meterReadingsEmpty: 'billingDetails.meterReadingsEmpty',
    multiRateReadsTitle: 'billingDetails.multiRateReadsTitle',
    meterReadingsTotalLabel: 'billingDetails.meterReadingsTotalLabel',
    meterReadingsTotalLabelWithRegister: 'billingDetails.meterReadingsTotalLabelWithRegister',
    meterReadingsTotalPeakLabel: 'billingDetails.meterReadingsTotalPeakLabel',
    meterReadingsTotalOffPeakLabel: 'billingDetails.meterReadingsTotalOffPeakLabel',
    meterReadingsTotal: 'billingDetails.meterReadingsTotal',
    comingSoon: 'billingSummary.comingSoon',
    billingSummaryDaysRemaining: 'billingSummary.daysRemaining',
    noChargesYet: 'billingSummary.noChargesYet',
    billPending: 'billingSummary.billPending',
    noCharges: 'billingSummary.noCharges',
    billAvailable: 'billingSummary.billAvailable',
    billingSummaryTitle: 'billingSummary.title',
    billingSummaryWelcomeNoPeriods: 'billingSummary.welcomeNoPeriods',
    understandBilling: 'billingSummary.understandBilling',
    understandBillingLink: 'billingSummary.understandBillingLink',
    noData: 'billingSummary.noData',
    helpCentre: 'billingSummary.helpCentre',
    viewFullHistory: 'billingSummary.viewFullHistory',
    otherChargesSectionHeading: 'billingDetails.otherChargesSectionHeading',
    otherChargesTotalLabel: 'billingDetails.otherChargesTotalLabel',
};
var defaultTranslations = (0, deepmerge_1.default)(core_1.translations, {
    en: {
        billingHistory: {
            title: 'Billing history',
            backtoHome: 'Back to home',
            headerText: "<P>We send your latest bill by email or post just after your bill end date each month. We'll upload your bill here shortly afterwards - ready to download</P>",
            viewCurrentBillingPeriod: 'View current billing period',
            viewDetails: 'View details',
            startingBalanceLabel: 'Starting balance',
            totalChargesLabel: 'Total charges',
            closingBalanceLabel: 'Closing balance',
            currentBalanceLabel: "Today's balance",
            loadMore: 'Load more',
            legacyBillingInfoHeader: 'Changes to how we show your billing',
            legacyBillingInfoDescription: "<P>Below you\u2019ll find bills from before your account was moved to our new online system \u2013 these don\u2019t show your online balance. The good news is, the new system now means we can update your energy account balance each time you (or your smart meter) send a reading. So you can track exactly how much energy you\u2019re using, and how much it\u2019s costing.</P>",
            pending: 'Bill pending',
            totalPaymentsLabel: 'Total payments',
            lastPeriodTitlePrepend: 'Last billing period:',
            currentPeriodTitlePrepend: 'Current billing period:',
            viewAllBills: 'View and download all bills',
            migrationTitle: "You've been migrated to our new system",
            migrationTextSingleTransaction: '<P>We migrated your account to our new system on <Strong>{{date}}</Strong>, with a balance of <Strong><CreditDebitBalance></CreditDebitBalance></Strong>.</P>',
            migrationTextMultipleTransaction: '<P>We migrated your account to our new system, and brought forward the following balances from the old system:</P>',
            migrationTextTransactionDetails: '<Strong><CreditDebitBalance></CreditDebitBalance></Strong> on {{date}}',
            migrationDual: '<P>This combines your gas and electricity into one single balance, and includes all charges up to the date you were migrated.</P>',
            migrationSingle: '<P>This balance includes all charges up to the date you were migrated</P>',
            migrationMultiple: '<P>These amounts include all charges up to the date each of your fuels was migrated, and have been combined so that you now have one single balance.</P>',
            noBillingTitle: "You don't have any bills yet",
            periodEndText: '<P>Your first billing period doesn’t end until <Strong>{{endDate}}</Strong> - come back after that date to see your first bill, or wait until you receive it by email or post.</P><P>To see your latest charges and payments, check out the <CurrentBillingPeriodLink>current billing period</CurrentBillingPeriodLink>.</P>',
            hasLegacyStatement: '<P>You can download your statements from the old system below.</P>',
            feedbackPromptLabel: 'How easy is it to understand your billing information?',
        },
        billingHistoryv2: {
            paymentsReceivedInPeriod: 'Payments received in this period',
            balanceAfterBill: 'Balance after this bill',
            downloadBill: '<P><DownloadBillLink>Download bill</DownloadBillLink></P>',
            viewFullBill: '<P><ViewDetailsLink>View full details</ViewDetailsLink></P>',
            payAmount: '<P><PayAmountLink>Pay this amount</PayAmountLink></P>',
            breakdownLabel: 'Breakdown',
            closingBalanceInCredit: '{{closingBalance}} in credit',
            closingBalanceInDebit: '{{closingBalance}} in debit',
            tooltipDescription: '{{percentageCharge}} of total charges',
            accessibleTooltipDescription: 'You spent {{spendString}} on {{item}} for this bill, which was {{percentageCharge}} of your total charges',
            tooltipDeductionDescription: '{{deductionAmount}} deducted from your charges',
            billingInsightsLabel: 'Good to know',
            actualLabel: 'Based on actual readings',
            accurateEstimateLabel: 'Accurately estimated thanks to your readings',
            estimateLabel: 'Estimated - <MeterReadsLink>please send a reading</MeterReadsLink>',
            actualElecLabel: 'Electricity based on actual readings',
            accurateEstimateElecLabel: 'Electricity accurately estimated thanks to your readings',
            estimateElecLabel: 'Electricity estimated - <MeterReadsLink fuel="electricity">please send a reading</MeterReadsLink>',
            actualGasLabel: 'Gas based on actual readings',
            accurateEstimateGasLabel: 'Gas accurately estimated thanks to your readings',
            estimateGasLabel: 'Gas estimated - <MeterReadsLink fuel="gas">please send a reading</MeterReadsLink>',
            creditBillLabel: 'This bill is a credit, not a charge',
            creditInsightTooltip: 'Sometimes, your credits can be more than your charges. When this happens your bill amount is a negative number, and your balance goes up.',
            ebbsInsightTooltip: "You've been credited with £{{amount}} as part of the Energy Bills Support Scheme. If you had a Direct Debit when this was added, it will be refunded to your bank account.",
            ebssCredit: 'Energy Bills Support Scheme discount added',
            otherCharges: 'Other Charges',
            credits: 'Credits',
            vat: 'VAT',
        },
        billingDetails: {
            back: 'View full billing history',
            billingDetailsTitle: 'Billing for {{startDate}} \u2013 {{endDate}}',
            billingDetailsTitleV2: '{{startDate}} \u2013 {{endDate}}',
            billingDetailsSubtitle: 'Detailed breakdown',
            accessibleTitle: 'Billing for {{startDate}} to the {{endDate}}',
            currentPeriod: '<P><Strong>This is your current billing period.</Strong> Your charges so far are <Strong>{{totalCharges}}</Strong>. <HowBillingWorksLink>See how billing works</HowBillingWorksLink></P>',
            helpWithNegativeCharges: '<P><HelpNegativeChargeLink><Small>Why is this a credit and not a charge?</Small></HelpNegativeChargeLink></P>',
            charges: '<P>Your charges for this period were <Strong>{{totalCharges}}</Strong>.</P>',
            chargesPending: '<P>Your charges for this period were <Strong>{{totalCharges}}</Strong>. We’re processing your energy usage and your downloadable bill should be available soon.</P>',
            download: 'Download bill',
            billingDetailsPending: 'Bill pending',
            balanceHeading: 'Your balance',
            currentBalanceHeading: "Your balance",
            balanceLastUpdated: 'Updated {{timeSinceBalanceLastUpdated}} ago',
            daysRemaining: "{{count}} day until end of billing period",
            daysRemaining_plural: "{{count}} days until end of billing period",
            totalChargesTitle: "<Strong>{{creditCharge}}</Strong> ",
            multiRateChargeLabel: "<CapitalisedRegisterLabel /> energy use charge",
            chargeLabel: "Energy use charge",
            chargeDetailsHeading: 'Charges in detail',
            chargeDetailsPeak: 'Peak',
            chargeDetailsOffpeak: 'Off-peak',
            energyCost: "<P><Strong>Cost of your energy</Strong></P>",
            noRecentReadingLink: "<P>\n      Your balance doesn't include charges for the energy\n      <br/>\n      you've used because we don't have a recent reading.\n      <br />\n      <NoChargesLink fuelType={{fuelType}}>Send your {{fuelType}} reading</NoChargesLink> and we'll update your balance.</P>",
            billingTableHeader: "Amount",
            dailyEnergyLinkMessage: "See your {{chargeRange}} daily energy use and what it cost",
            emptyCurrentStateTitle: 'Current billing period',
            emptyCurrentStateSubtitle: "There haven't been any charges or payments in this billing period yet. <HowBillingWorksLink>See how billing works</HowBillingWorksLink>",
            emptyCurrentStateBalanceSubtitle: '<P>No charges or payments yet</P>',
            emptyCurrentStateBalanceBody: '<P>You’ll see up-to-date billing as soon as we get a new meter reading or a payment. You can give a meter reading now, if you like.</P>',
            emptyCurrentStateBalanceSubmitMeterReading: 'Meter readings',
            emptyStateSmartMeterSubtitle: 'Your new billing period starts soon. <HowBillingWorksLink>See how billing works</HowBillingWorksLink>',
            emptyStateSmartMeterBalanceBody: "<P>Don't worry, you\u2019ll see up-to-date billing as soon as we get a new reading from your smart meter.</P>",
            emptyStateSmartNonCommsBalanceBody: "<P>We're having trouble getting automatic readings from your smart meter. To see up-to-date billing, please send us a reading below.</P>",
            feedbackPromptLabel: 'How easy is it to understand your billing information?',
            unitsUsed: 'Units used ',
            totalKwh: "{{total}} kwh",
            sendYourFuelReading: "Send your {{fuel}} reading",
            upgradesTitle: 'Upgrades',
            otherChargesTitle: 'Other charges',
            fuelSectionTitle: 'Standing charge',
            balanceSectionHeading: 'Balance changes',
            balanceSectionOpeningHeading: 'Opening',
            balanceSectionChargesHeading: 'Charges',
            balanceSectionChargesDetails: 'See details',
            balanceSectionPaymentsHeading: 'Payments',
            balanceSectionPaymentsDetails: 'See details',
            balanceSectionClosingHeading: 'Closing',
            otherChargesSectionHeading: 'Other charges',
            otherChargesTotalLabel: '<Strong>Total</Strong>',
            gasSectionTitle: 'Gas',
            electricitySectionTitle: 'Electricity',
            chargesTableTitle: 'Charges',
            chargesTableTotalLabel: '<Strong>Total cost</Strong> (before VAT)',
            noChargesInPeriod: '<P>No charges in this period.</P>',
            inCredit: 'in credit',
            inDebit: 'in debit',
            totalChargesSectionHeader: 'Total charges',
            paymentsSectionHeader: 'Payments',
            paymentsSectionEmpty: '<P>No payments received in this period.</P>',
            meterReadingsHeader: 'Meter readings',
            meterReadingsEmpty: "<P>We don't have any meter readings to calculate your energy use.</P><P><SendMeterReadingLink fuel=\"{{fuel}}\">Send {{fuel}} reading</SendMeterReadingLink></P>",
            multiRateReadsTitle: "<CapitalisedRegisterLabel /> meter readings",
            meterReadingsTotalLabel: "<Strong>Total energy use</Strong>",
            meterReadingsTotalLabelWithRegister: "<Strong data-testid=\"meter-reads-register-total-label\">Total <RegisterLabel /> energy use</Strong>",
            meterReadingsTotal: "<Strong>{{total}} kWh</Strong>",
            meterReadingsTotalPeakLabel: "<Strong>Total peak energy use</Strong>",
            meterReadingsTotalOffPeakLabel: "<Strong>Total off-peak energy use</Strong>",
        },
        billingSummary: {
            title: 'Your bills',
            welcomeNoPeriods: "<P>Welcome to your billing summary. Once you start using energy, we'll show your recent bills here.</P>",
            understandBilling: '<P><UnderstandBillingLink>Understand how billing works</UnderstandBillingLink></P>',
            understandBillingLink: 'Understand how billing works',
            noData: "<P>We can't show you this data right now - check back again soon.</P>",
            helpCentre: '<P><HelpCentreLink>Visit the help centre</HelpCentreLink></P>',
            comingSoon: 'Coming soon',
            daysRemaining: 'Ends in {{count}} day',
            daysRemaining_plural: 'Ends in {{count}} days',
            noChargesYet: 'No charges yet',
            billPending: 'Bill pending',
            noCharges: 'No charges',
            billAvailable: 'Bill available',
            viewFullHistory: 'View full billing history',
        },
    },
});
var defaultOptions = {
    keys: keys,
    defaultTranslations: defaultTranslations,
    components: {
        HelpNegativeChargeLink: HelpNegativeChargeLink,
        HowBillingWorksLink: HowBillingWorksLink,
        NoChargesLink: NoChargesLink,
        HelpCentreLink: HelpCentreLink,
        DownloadBillLink: DownloadBillLink,
        ViewDetailsLink: ViewDetailsLink,
        PayAmountLink: PayAmountLink,
        UnderstandBillingLink: UnderstandBillingLink,
        CreditDebitBalance: CreditDebitBalance,
        CurrentBillingPeriodLink: CurrentBillingPeriodLink,
        MeterReadsLink: MeterReadsLink,
        SendMeterReadingLink: SendMeterReadingLink,
        RegisterLabel: registers_1.RegisterLabel,
        CapitalisedRegisterLabel: CapitalisedRegisterLabel,
    },
};
exports.defaultOptions = defaultOptions;
